// src/components/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const NAV = [
  { to: '/dashboard', icon: '🌌', label: 'Dashboard' },
  { to: '/kundli',    icon: '📜', label: 'Kundali' },
  { to: '/horoscope', icon: '♈', label: 'Horoscope' },
  { to: '/match',     icon: '💞', label: 'Matchmaking' },
  { to: '/profile',   icon: '👤', label: 'Profile' },
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [biz, setBiz]   = useState({
    business_name:    'AstroVeda',
    business_tagline: 'Cosmic Insights',
    logo_text:        '🔮',
    pandit_name:      '',
    pandit_title:     '',
  });

  useEffect(() => {
    axios.get((window.location.hostname==='localhost'||window.location.hostname==='127.0.0.1'?'http://localhost/astrology/api':'https://astrology.infotrix.in/api')+'/settings/settings.php')
      .then(r => { if (r.data?.settings) setBiz(r.data.settings); })
      .catch(() => {});
  }, []);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="flex min-h-screen relative">
      <div className="glow-orb w-96 h-96 bg-cosmic-600/20 -top-20 -left-20" />
      <div className="glow-orb w-64 h-64 bg-purple-900/30 bottom-20 right-10" />

      <aside className={"fixed inset-y-0 left-0 z-30 w-64 flex flex-col bg-cosmic-950/95 backdrop-blur-xl border-r border-cosmic-800/40 transform transition-transform duration-300 " + (open ? "translate-x-0" : "-translate-x-full") + " lg:translate-x-0 lg:relative lg:flex"}>

        <div className="flex items-center gap-3 px-6 py-6 border-b border-cosmic-800/40">
          <span className="text-3xl animate-float">{biz.logo_text || '🔮'}</span>
          <div>
            <h1 className="font-cinzel text-lg font-bold text-white tracking-wide">{biz.business_name || 'AstroVeda'}</h1>
            <p className="text-xs text-cosmic-400">{biz.business_tagline || 'Cosmic Insights'}</p>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map(({ to, icon, label }) => (
            <NavLink key={to} to={to} onClick={() => setOpen(false)}
              className={({ isActive }) => "nav-link " + (isActive ? "active" : "")}>
              <span className="text-base">{icon}</span>
              <span>{label}</span>
            </NavLink>
          ))}
          {isAdmin && (
            <NavLink to="/admin" onClick={() => setOpen(false)}
              className={({ isActive }) => "nav-link mt-2 " + (isActive ? "active" : "")}>
              <span className="text-base">⚙️</span>
              <span>Admin Panel</span>
            </NavLink>
          )}
        </nav>

        {biz.pandit_name && (
          <div className="px-4 py-3 border-t border-cosmic-800/20 bg-amber-900/5">
            <p className="text-xs text-amber-400 font-semibold">🙏 {biz.pandit_name}</p>
            <p className="text-xs text-cosmic-500">{biz.pandit_title || 'Vedic Astrologer'}</p>
          </div>
        )}

        <div className="px-4 py-4 border-t border-cosmic-800/40">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-cosmic-500 to-purple-700 flex items-center justify-center text-white font-bold text-sm">
              {user?.name?.[0]?.toUpperCase() ?? '?'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-white truncate">{user?.name}</p>
              <p className="text-xs text-cosmic-400 truncate">{user?.email}</p>
            </div>
          </div>
          <button onClick={handleLogout} className="btn-outline w-full text-sm py-2">Sign Out</button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 z-20 bg-black/60 lg:hidden" onClick={() => setOpen(false)} />}

      <div className="flex-1 flex flex-col min-h-screen min-w-0">
        <header className="lg:hidden flex items-center justify-between px-4 py-3 border-b border-cosmic-800/40 bg-cosmic-950/80 backdrop-blur sticky top-0 z-10">
          <button onClick={() => setOpen(true)} className="text-cosmic-300 hover:text-white p-1">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <span className="font-cinzel font-bold text-white">{biz.logo_text} {biz.business_name}</span>
          <div className="w-7" />
        </header>
        <main className="flex-1 p-4 lg:p-8 relative z-10"><Outlet /></main>
      </div>
    </div>
  );
}
